import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import Button from '../common/Button';
import { motion } from 'framer-motion';
import { db } from '../../services/db';

const Hero = () => {
  const { t, language } = useLanguage();
  const [content, setContent] = useState(null);

  useEffect(() => {
    db.getHeroContent().then(setContent).catch(() => setContent(null));
  }, []);

  const title = content ? (language === 'es' ? content.titleEs : content.titleEn) : t('hero.title');
  const subtitle = content ? (language === 'es' ? content.subtitleEs : content.subtitleEn) : t('hero.subtitle');
  const statsNumber = content?.statsNumber ?? '5,000+';
  const statsText = content ? (language === 'es' ? content.statsTextEs : content.statsTextEn) : (language === 'es' ? 'Mujeres empoderadas en nuestra comunidad global.' : 'Women empowered in our global community.');
  const bgImage = content?.backgroundImage || 'https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&q=80&w=1000';

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-gradient-to-br from-pink-50 via-white to-pink-100">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-pink-600/5 skew-x-12 transform origin-top-right" />
      
      <div className="container mx-auto px-4 z-10 grid md:grid-cols-2 gap-12 items-center">
        <motion.div 
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="text-left"
        >
          <span className="inline-block px-4 py-1 bg-pink-100 text-pink-700 rounded-full text-sm font-bold mb-4 tracking-wider uppercase">
            Mujeres y Riquezas
          </span>
          <h1 className="text-5xl md:text-7xl font-extrabold text-gray-900 mb-6 leading-tight">
            {title}
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-lg leading-relaxed">
            {subtitle}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button onClick={() => document.getElementById('scorecard').scrollIntoView({ behavior: 'smooth' })}>
              {t('hero.cta')}
            </Button>
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="relative"
        >
          <div className="aspect-[4/5] rounded-tl-[100px] rounded-br-[100px] overflow-hidden shadow-2xl border-8 border-white">
            <img 
              src={bgImage} 
              alt="Powerful Business Woman" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-black text-white p-6 rounded-lg shadow-xl max-w-xs">
            <p className="font-bold text-2xl text-pink-500">{statsNumber}</p>
            <p className="text-sm">{statsText}</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;